/**
 * Convert labels (with underscores) to field names in query text
 * 
 * This function converts user-friendly labels to canonical field names
 * before sending queries to the backend. Labels with spaces are converted
 * to underscores (e.g., "Created By" -> "Created_By").
 * 
 * @param {string} text - Query text containing labels
 * @param {Object} schema - Query schema with field definitions
 * @returns {string} Query text with field names instead of labels
 */
export function labelsToFieldNames(text, schema) {
  if (!text || !schema?.fields) return text;
  
  const labelMap = new Map();
  
  schema.fields.forEach(field => {
    const fieldName = field.name;
    labelMap.set(fieldName.toLowerCase(), fieldName);
    
    if (field.label) {
      const labelKey = field.label.replace(/\s+/g, '_');
      labelMap.set(labelKey.toLowerCase(), fieldName);
      labelMap.set(field.label.toLowerCase(), fieldName);
    }
  });
  
  if (labelMap.size === 0) {
    return text;
  }
  
  let processedText = text;
  const sortedEntries = Array.from(labelMap.entries())
    .sort((a, b) => b[0].length - a[0].length);
  
  sortedEntries.forEach(([labelKey, fieldName]) => {
    const escapedLabel = labelKey.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(`\\b${escapedLabel}\\b(?=\\s|$|\\s*[=!<>]|\\s*\\(|\\s*\\[|\\.)`, 'gi');
    processedText = processedText.replace(pattern, fieldName);
  });
  
  return processedText;
}

